import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';


import { ModulosController } from '../../modulos-controller';
import { MenuService } from '../../../../providers/menu-service';

import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ContasBancariasService } from '../../../../providers/contas-bancarias-service';
import { ContabilidadeService } from '../../../../providers/contabilidade-service';
import { ModalContasBancariasPage } from '../../../modais/modal-contas-bancarias/modal-contas-bancarias';
import { ModalArquivosPage } from '../../../modais/modal-arquivos/modal-arquivos';

declare var jsPDF: any;

@Component({
  selector: 'page-contas-bancarias',
  templateUrl: 'contas-bancarias.html',
  providers: [
    ContasBancariasService,
    ContabilidadeService
  ]
})
export class ContasBancariasPage extends ModulosController {
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

  listaTipoContas: any = [];
  listaBancos: any = [];
  listaDiferencas: any = [];
  codigoModulo: any = null;
  listaContasCadastradas: any = [];
  isSefaz: boolean = false;

  loading: boolean = true;

  comboConta: any = [];
  comboBanco: any = [];
  comboDiferenca: any = [];

  contaBancariaAdicionar: any = {
    "idConta": 0,
    "idTipoConta": "",
    "idBanco": "",
    "dsAgencia": "",
    "numeroConta": "",
    "dsVinculada": "",
    "saldoExtrato": "",
    "saldoS2GPR": "",
    "diferencas": [],
    "idPca": this.gestaoPcaService.getPCA().id
  }

  analise: any = null;

  //Construtor da Página
  constructor(
    public contasBancariasService: ContasBancariasService,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public contabilidadeService: ContabilidadeService,
    public menuService: MenuService,
    public gestaoPcaService: GestaoPcaService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.codigoModulo = this.navParams.get('analise').idModuloPca;

    this.listarContas();
    this.setModuloId(24);

    console.log(this.listaContasCadastradas[0]);
    //this.isSefaz = this.listaContasCadastradas[0].flSefaz;
  }

  listarContas() {
    this.loading = true;
    this.contasBancariasService.listarContas().subscribe(data => {
      this.listaContasCadastradas = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um problema em listar contas cadastradas.");
      this.loading = false;
    });
  }

  deletarConta(objetoConta) {
    this.alertService.mostraModalConfirmacao("Remover Conta Bancária", "Deseja remover a Conta Bancária?", callback => {
      if (callback) {
        this.loading = true;
        let index = this.listaContasCadastradas.indexOf(objetoConta);
        this.listaContasCadastradas.splice(index, 1);

        this.contasBancariasService.removerConta(objetoConta.idConta).subscribe(data => {
          this.alertService.mostraAlerta("", "Conta removida com sucesso.");
          this.loading = false;
          // this.carregarModulo();
        }, error => {
          console.log("erro: " + error.mensagem);
          this.alertService.mostraAlerta("Houve um problema ao deletar conta.", error.mensagem);
          this.loading = false;
        });
      } 
    });
  }


  abrirContasBancarias(objetoConta) {
    let titulo = "Contas Bancárias";

    let modal = this.modalCtrl.create(ModalContasBancariasPage,
      {
        titulo: titulo,
        objetoConta: objetoConta,
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        analise: this.analise,
        isSefaz: this.isSefaz
      });
    modal.onDidDismiss(retornoModal => {
      this.carregarModulo();
      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }


  novaConta(objetoConta) {
    let titulo = "Contas Bancárias";

    let modal = this.modalCtrl.create(ModalContasBancariasPage,
      {
        titulo: titulo,
        objetoConta: objetoConta,
        jurisdicionado: this.isJurisdicionado,
        analise: this.analise,
        isSefaz: this.isSefaz
      });
    modal.onDidDismiss(retornoModal => {
      this.carregarModulo();

      this.contaBancariaAdicionar.idConta = 0;
      this.contaBancariaAdicionar.idTipoConta = "";
      this.contaBancariaAdicionar.idBanco = "";
      this.contaBancariaAdicionar.dsAgencia = "";
      this.contaBancariaAdicionar.numeroConta = "";
      this.contaBancariaAdicionar.dsVinculada = "";
      this.contaBancariaAdicionar.saldoExtrato = "";
      this.contaBancariaAdicionar.saldoS2GPR = "";
      this.contaBancariaAdicionar.diferencas = [];
      this.contaBancariaAdicionar.idPca = this.gestaoPcaService.getPCA().id;


      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }

  voltarParaContabilidade() {
    this.menuService.redirecionarPagina(this.contabilidadeService.obterIdPaginaContabilidade());
  }

  abrirListarArquivo(item) {
    let titulo = "Peças Processuais";

    console.log("BANCO_" + item.nmBanco + "_AG_" + item.dsAgencia + "_CC_" + item.numeroConta);

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.idConta,
        idModuloPCA: this.codigoModulo,
        tipoAnalise: '1901',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemArquivo: "BANCO_" + item.nmBanco.replace(" ", "_") + "_AG_" + item.dsAgencia + "_CC_" + item.numeroConta,
        origemFilter: 'EXTRATO CONTA CORRENTE',
        tipoEntidadeExercicio: item.pecaProcessual.idTipoEntidadeExercicio,
        tipodocumento: 45,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }


  redirecionarParaAnalise(item) {

    let analise = this.navParams.get('analise');

    analise.idProcesso = item.idConta;
    analise.cdAnalise = "1901"
    this.menuService.redirecionarSubPagina(this.contabilidadeService.obterIdPaginaContabilidade(), analise);
  }

  salvar() {

    this.contasBancariasService.salvarModulo(this.listaContasCadastradas, this.contabilidadeService.codigoModuloContabilidade).subscribe(data => {
      this.alertService.mostraAlerta("", "Salvo com sucesso.");
      this.carregarModulo();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      this.loading = false;
    })
  }

  finalizar() {
    if (this.listaContasCadastradas) {
      this.contasBancariasService.finalizarModulo(this.listaContasCadastradas, this.contabilidadeService.codigoModuloContabilidade).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.voltarParaContabilidade();
      }, error => {
        console.log(error);
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar: " + error.mensagem);
      });
    }
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Contas Bancárias", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Tipo de Conta", dataKey: "tipo" },
      { title: "Banco", dataKey: "banco" },
      { title: "Agência", dataKey: "agencia" },
      { title: "Conta", dataKey: "conta" },
      { title: "Vinculado à", dataKey: "vinculado" },
      { title: "Saldo Extrato", dataKey: "extrato" },
      { title: "Saldo SIAFE", dataKey: "SIAFE" }
    ];

    let rows = [];

    this.listaContasCadastradas.forEach(contrato => {

      var item = {
        "tipo": contrato.dsTipoConta,
        "banco": contrato.nmBanco,
        "agencia": contrato.dsAgencia,
        "conta": contrato.numeroConta,
        "vinculado": contrato.dsVinculada,
        "extrato": contrato.saldoExtrato ? this.formatarValorNumerico(contrato.saldoExtrato) : "0",
        "SIAFE": contrato.saldoS2GPR ? this.formatarValorNumerico(contrato.saldoS2GPR) : "0"
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      theme: 'grid',
      addPageContent: pageContent,
      margin: { top: 30 },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'auto',
        fontSize: 8
      },
      columnStyles: {
        desc: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('contas_bancarias.pdf');
  }

}





// WEBPACK FOOTER //
// ./src/pages/modulos/relatorios-contabeis/contas-bancarias/contas-bancarias.ts